import React from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  return (
    <Box component="main" sx={{ bgcolor: '#fff' }}>
      <Box
        component="section"
        sx={{
          color: '#fff',
          backgroundImage: 'linear-gradient(rgba(7,18,36,.72), rgba(7,18,36,.72)), url(/media/hero-property-poster.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Container maxWidth="lg" sx={{ py: { xs: 7, md: 10 } }}>
          <Typography variant="overline" sx={{ color: 'rgba(255,255,255,.7)', letterSpacing: '.14em' }}>Contact MRM Lettings</Typography>
          <Typography component="h1" sx={{ mt: 1, fontSize: { xs: '2.5rem', md: '4rem' }, fontWeight: 800, letterSpacing: '-.04em' }}>How can we help?</Typography>
          <Typography sx={{ mt: 2, maxWidth: 620, color: 'rgba(255,255,255,.8)', fontSize: '1.1rem' }}>
            Contact our Middlesbrough office about a property, valuation, tenancy or managed service.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 7, md: 10 } }}>
        <Grid container spacing={{ xs: 3, md: 5 }} alignItems="stretch">
          <Grid size={{ xs: 12, md: 5 }}>
            <Paper elevation={0} sx={{ height: '100%', p: { xs: 3, md: 4 }, bgcolor: '#f5f7fb', border: '1px solid #e2e8f0' }}>
              <Typography variant="overline" color="primary.main">Our office</Typography>
              <Typography variant="h4" sx={{ mt: 1 }}>Middlesbrough</Typography>
              <Stack spacing={2.2} sx={{ mt: 3 }}>
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <LocationOnOutlined color="primary" />
                  <Box>
                    <Typography>142 Victoria Road<br />Middlesbrough, TS1 3HU</Typography>
                    <Link href="https://www.google.com/maps/search/?api=1&query=142+Victoria+Road+Middlesbrough+TS1+3HU" target="_blank" rel="noopener" underline="hover" sx={{ display: 'inline-block', mt: 0.5 }}>View on Google Maps</Link>
                  </Box>
                </Stack>
                <Link href="tel:+441642243378" color="inherit" underline="hover" sx={contactLinkSx}><PhoneOutlined color="primary" />01642 243 378</Link>
                <Link href="mailto:info@mrmlettings.co.uk" color="inherit" underline="hover" sx={contactLinkSx}><EmailOutlined color="primary" />info@mrmlettings.co.uk</Link>
              </Stack>
              <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #dbe2ea' }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5 }}>Useful links</Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                  <Button component={RouterLink} to="/repairs" variant="outlined">Report a repair</Button>
                  <Button component={RouterLink} to="/payments" variant="text">Payment guidance</Button>
                </Stack>
              </Box>
            </Paper>
          </Grid>

          <Grid size={{ xs: 12, md: 7 }}>
            <Paper elevation={0} sx={{ height: '100%', p: { xs: 3, md: 4.5 }, border: '1px solid #e2e8f0' }}>
              <Typography variant="overline" color="primary.main">Send an enquiry</Typography>
              <Typography variant="h4" sx={{ mt: 1 }}>Send us a message</Typography>
              <Typography sx={{ mt: 1, mb: 3, color: 'text.secondary' }}>Tell us what you need and include the property address where relevant.</Typography>
              <ContactForm />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

const contactLinkSx = { display: 'inline-flex', alignItems: 'center', gap: 1.5, width: 'fit-content' };
